'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

interface RefPageProps {
  params: { ref: string }
}

export default function RefPage({ params }: RefPageProps) {
  const router = useRouter()

  useEffect(() => {
    localStorage.setItem('r', params.ref)
    router.push('/')
  }, [])

  return null
}
